export type {
  ApiError,
  ApiErrorKind,
  CrossrefAuthor,
  CrossrefWork,
  OpenAlexAuthor,
  OpenAlexWork,
  PubMedAuthor,
  PubMedRecord,
  ReferenceAuditEntry,
  ReferenceAuditOutcome,
  ReferenceAuditResult,
  Result,
  ReviewerCandidate,
  ReviewerSearchResult,
} from './types';

export { resolveDoi } from './crossref';
export { searchWorks } from './openalex';
export { searchPubmed } from './pubmed';
export { searchReviewers } from './reviewers';
export type { ReviewerSearchInput } from './reviewers';
export { auditReferences } from './reference-audit';
export type { ReferenceAuditOptions } from './reference-audit';

import { searchReviewers } from './reviewers';
import { auditReferences } from './reference-audit';
import type { PatternRunResult } from '../patterns';
import type { ReferenceAuditResult, ReviewerSearchResult } from './types';

export interface ApiAnalysisInput {
  pattern: PatternRunResult;
  /** Surnames of the manuscript's authors, lowercased (for COI filter). */
  excludeAuthors?: string[];
  /** Institution substrings, lowercased (for COI filter). */
  excludeAffiliations?: string[];
  mailto?: string;
  ncbiApiKey?: string;
}

export interface ApiAnalysisResult {
  referenceAudit: ReferenceAuditResult;
  reviewers: ReviewerSearchResult;
}

/**
 * Runs both upstream-API workflows in parallel after pattern analysis.
 * Each sub-result carries its own `degraded` flag per PRD §9.7.
 */
export async function runApiAnalysis(input: ApiAnalysisInput): Promise<ApiAnalysisResult> {
  const keywords = input.pattern.keywords.map((k) => k.term);
  const [referenceAudit, reviewers] = await Promise.all([
    auditReferences(input.pattern.references, { mailto: input.mailto }),
    searchReviewers({
      keywords,
      excludeAuthors: input.excludeAuthors ?? [],
      excludeAffiliations: input.excludeAffiliations ?? [],
      mailto: input.mailto,
      ncbiApiKey: input.ncbiApiKey,
    }),
  ]);
  return { referenceAudit, reviewers };
}
